interface FlowAwarenessIconProps {
    size?: number;
    className?: string;
  }
  
  export default function FlowAwarenessIcon({ 
    size = 128, 
    className = "" 
  }: FlowAwarenessIconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="-1 -1 78 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <defs>
          {/* Masks - white area is visible, black area is hidden */}
          <mask id="mask-bubble1-v2">
            <rect x="-5" y="-5" width="100" height="100" fill="white" />
            {/* Second bubble shape masks first bubble */}
            <path
              d="M 38 23 C 38 20 38 18 41 18 L 71 18 C 74 18 74 20 74 23 L 74 37 C 74 40 74 42 71 42 L 68 42 L 68 49 L 61 42 L 41 42 C 38 42 38 40 38 37 Z"
              fill="black"
              stroke="black"
              strokeWidth="3"
            />
          </mask>
          
          <mask id="mask-bubble2-v2">
            <rect x="-5" y="-5" width="100" height="100" fill="white" />
            {/* Third bubble shape masks second bubble */}
            <path
              d="M 5 41 C 5 38 5 36 8 36 L 38 36 C 41 36 41 38 41 41 L 41 55 C 41 58 41 60 38 60 L 15 60 L 8 67 L 8 60 C 5 60 5 58 5 55 Z"
              fill="black"
              stroke="black"
              strokeWidth="3"
            />
          </mask>
          
          <mask id="mask-bubble3-v2">
            <rect x="-5" y="-5" width="100" height="100" fill="white" />
            {/* Fourth bubble shape masks third bubble */}
            <path
              d="M 38 59 C 38 56 38 54 41 54 L 71 54 C 74 54 74 56 74 59 L 74 73 C 74 76 74 78 71 78 L 68 78 L 68 85 L 61 78 L 41 78 C 38 78 38 76 38 73 Z"
              fill="black"
              stroke="black"
              strokeWidth="3"
            />
          </mask>
        </defs>
        
        {/* First bubble - from left (customer) */}
        <path
          d="M 5 5 C 5 2 5 0 8 0 L 38 0 C 41 0 41 2 41 5 L 41 19 C 41 22 41 24 38 24 L 15 24 L 8 31 L 8 24 C 5 24 5 22 5 19 Z"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinejoin="round"
          mask="url(#mask-bubble1-v2)"
        />
        {/* First bubble content: Row 1 - filled circle and empty circle */}
        <circle cx="16" cy="8" r="2.5" fill="currentColor" />
        <circle cx="26" cy="8" r="2.5" fill="none" stroke="currentColor" strokeWidth="1" />
        {/* First bubble content: Row 2 - filled bar */}
        <rect x="13" y="14" width="16" height="3" rx="1.5" fill="currentColor" />
  
        {/* Second bubble - from right (agent) */}
        <path
          d="M 38 23 C 38 20 38 18 41 18 L 71 18 C 74 18 74 20 74 23 L 74 37 C 74 40 74 42 71 42 L 68 42 L 68 49 L 61 42 L 41 42 C 38 42 38 40 38 37 Z"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinejoin="round"
          mask="url(#mask-bubble2-v2)"
        />
        {/* Second bubble content: two bars same size - one empty, one filled */}
        <rect x="45" y="28" width="10" height="3" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1" />
        <rect x="57" y="28" width="10" height="3" rx="1.5" fill="currentColor" />
  
        {/* Third bubble - from left (customer) */}
        <path
          d="M 5 41 C 5 38 5 36 8 36 L 38 36 C 41 36 41 38 41 41 L 41 55 C 41 58 41 60 38 60 L 15 60 L 8 67 L 8 60 C 5 60 5 58 5 55 Z"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinejoin="round"
          mask="url(#mask-bubble3-v2)"
        />
        {/* Third bubble content: one filled bar (same size as bubble 2) */}
        <rect x="13" y="46" width="10" height="3" rx="1.5" fill="currentColor" />
  
        {/* Fourth bubble - from right (agent) - final solution */}
        <path
          d="M 38 59 C 38 56 38 54 41 54 L 71 54 C 74 54 74 56 74 59 L 74 73 C 74 76 74 78 71 78 L 68 78 L 68 85 L 61 78 L 41 78 C 38 78 38 76 38 73 Z"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinejoin="round"
        />
        {/* Fourth bubble content: Row 1 - filled circle (centered) */}
        <circle cx="54" cy="59" r="2.5" fill="currentColor" />
        {/* Fourth bubble content: Row 2 - filled bar same size as bubbles 2&3 (centered) */}
        <rect x="49" y="64" width="10" height="3" rx="1.5" fill="currentColor" />
        {/* Fourth bubble content: Row 3 - filled bar same as bubble 1 (centered) */}
        <rect x="46" y="70" width="16" height="3" rx="1.5" fill="currentColor" />
      </svg>
    );
  }
  